import React, { memo, useEffect, useState } from 'react'
import { useTbViewStore } from '@vt/hooks'
import PdfPreview from './pdfPreview'
import logo from './assets/logo.png'

const ShareDetail = ({ objectId, onError }) => {
  const fetchTbDataById = useTbViewStore((state) => state.fetchTbDataById)

  const [file, setFile] = useState()

  useEffect(() => {
    fetchTbDataById(objectId)
      .then((res) => {
        if (res.originalData.file) {
          setFile(res.originalData.file[0].src)
        } else {
          onError('未查询到文章信息，请联系管理员上传文章')
        }
      })
      .catch((err) => {
        console.log(err)
        onError('未查询到分享信息，请联系管理员重新分享')
      })
  }, [objectId])

  return (
    <div className="w-full h-full bg-white flex flex-col items-center">
      <img style={{ maxWidth: 'min(500px, 80%)' }} src={logo} alt="" />
      {file && <PdfPreview file={file} />}
    </div>
  )
}

export default memo(ShareDetail)
